export enum OmsConditionType {
  ORDER_TAG = "ORDER_TAG",
  SELECTED_SHIPPING = "SELECTED_SHIPPING",
  SKU = "SKU",
  PRODUCT_NAME = "PRODUCT_NAME",
  VARIANT_TITLE = "VARIANT_TITLE",
  PRODUCT_TYPE = "PRODUCT_TYPE",
  ITEM_QUANTITY = "ITEM_QUANTITY",
  PACKAGE_WEIGHT_OZ = "PACKAGE_WEIGHT",
  TOTAL_VALUE = "TOTAL_VALUE",
  TAXES_PAID = "TAXES_PAID",
  DESTINATION_COUNTRY = "DESTINATION_COUNTRY",
  DESTINATION_PROVINCE = "DESTINATION_PROVINCE",
  DELIVERY_METHOD = "DELIVERY_METHOD",
  STREET_ADDRESS = "STREET_ADDRESS",
  STREET_ADDRESS_LIST_INPUT = "STREET_ADDRESS_LIST_INPUT",
  ZIP_CODE = "ZIP_CODE",
  SALES_CHANNEL = "SALES_CHANNEL",
  PRODUCT_TAG = "PRODUCT_TAG",
  FULFILLMENT_LOCATION = "FULFILLMENT_LOCATION",
  ORIGIN_STORE = "ORIGIN_STORE",
  ORDER_NOTES = "ORDER_NOTES",
  ORDER_NUMBER = "ORDER_NUMBER",
  FRAUD_RISK = "FRAUD_RISK",
  AVAILABLE_INVENTORY = "AVAILABLE_INVENTORY",
  MARKETPLACE = "MARKETPLACE",
  SHIPMENT_TAG = "SHIPMENT_TAG",
  CUSTOM_STRING_1 = "CUSTOM_STRING_1",
  CUSTOM_STRING_2 = "CUSTOM_STRING_2",
  CUSTOM_STRING_3 = "CUSTOM_STRING_3",
  CUSTOM_NUMBER_1 = "CUSTOM_NUMBER_1",
  CUSTOM_NUMBER_2 = "CUSTOM_NUMBER_2",
  CUSTOM_NUMBER_3 = "CUSTOM_NUMBER_3",
  CUSTOM_DATE_1 = "CUSTOM_DATE_1",
  CUSTOM_DATE_2 = "CUSTOM_DATE_2",
  CUSTOM_DATE_3 = "CUSTOM_DATE_3",
  PRODUCT_CUSTOM_STRING_1 = "PRODUCT_CUSTOM_STRING_1",
  PRODUCT_CUSTOM_STRING_2 = "PRODUCT_CUSTOM_STRING_2",
  PRODUCT_CUSTOM_STRING_3 = "PRODUCT_CUSTOM_STRING_3",
  PRODUCT_CUSTOM_NUMBER_1 = "PRODUCT_CUSTOM_NUMBER_1",
  PRODUCT_CUSTOM_NUMBER_2 = "PRODUCT_CUSTOM_NUMBER_2",
  PRODUCT_CUSTOM_NUMBER_3 = "PRODUCT_CUSTOM_NUMBER_3",
  PRODUCT_CUSTOM_DATE_1 = "PRODUCT_CUSTOM_DATE_1",
  PRODUCT_CUSTOM_DATE_2 = "PRODUCT_CUSTOM_DATE_2",
  PRODUCT_CUSTOM_DATE_3 = "PRODUCT_CUSTOM_DATE_3",
  CUSTOM_ATTRIBUTE_STRING_1 = "CUSTOM_ATTRIBUTE_STRING_1",
  CUSTOM_ATTRIBUTE_STRING_2 = "CUSTOM_ATTRIBUTE_STRING_2",
  CUSTOM_ATTRIBUTE_STRING_3 = "CUSTOM_ATTRIBUTE_STRING_3",
  CUSTOM_ATTRIBUTE_NUMBER_1 = "CUSTOM_ATTRIBUTE_NUMBER_1",
  CUSTOM_ATTRIBUTE_NUMBER_2 = "CUSTOM_ATTRIBUTE_NUMBER_2",
  CUSTOM_ATTRIBUTE_NUMBER_3 = "CUSTOM_ATTRIBUTE_NUMBER_3",
  CUSTOM_ATTRIBUTE_DATE_1 = "CUSTOM_ATTRIBUTE_DATE_1",
  CUSTOM_ATTRIBUTE_DATE_2 = "CUSTOM_ATTRIBUTE_DATE_2",
  CUSTOM_ATTRIBUTE_DATE_3 = "CUSTOM_ATTRIBUTE_DATE_3",
  CUSTOMER_NAME = "CUSTOMER_NAME",
  CUSTOMER_ORDER_COUNT = "CUSTOMER_ORDER_COUNT",
  CUSTOMER_TAG = "CUSTOMER_TAG",
  RECOGNIZE_SEGMENT = "RECOGNIZE_SEGMENT",
  ITEM_COST = "ITEM_COST",
  VENDOR = "VENDOR",
  USPS_ZONE = "USPS_ZONE",
  LINE_ITEM_CUSTOM_ATTRIBUTE = "LINE_ITEM_CUSTOM_ATTRIBUTE",
  ADDRESS_VERIFIED = "ADDRESS_VERIFIED",
  MARKETPLACE_INTERNAL_NOTES = "MARKETPLACE_INTERNAL_NOTES",
  PACKAGE_IS_LEARNED = "PACKAGE_IS_LEARNED",
  DESTINATION_FORECAST_TEMPERATURE = "DESTINATION_FORECAST_TEMPERATURE",
}
